<template lang="html">
  <el-dialog
    title="拒绝报价原因"
    v-if="dialogVisible"
    :visible="dialogVisible"
    @close="close"
    append-to-body
    width="500px"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width=""
      label-position="left"
      class="add-goods-form"
    >
      <el-form-item label="" prop="refusal">
        <el-input
          type="textarea"
          v-model="ruleForm.refusal"
          placeholder="请输入拒绝报价原因"
          :rows="4"
          style="width:100%;"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit" :loading="loading"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import qs from "qs";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      ruleForm: {},
      rules: {},
      loading: false
    };
  },
  computed: {},
  created() {},
  methods: {
    close() {
      this.$emit("update:dialogVisible", false);
    },
    initData() {
      this.ruleForm = {
        refusal: ""
      };
      this.rules = {
        refusal: [
          {
            required: true,
            message: "请输入拒绝报价原因",
            trigger: ["blur", "change"]
          }
        ]
      };
    },
    submit() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          try {
            this.loading = true;
            await this.$http.post(
              "/shipper/order-shipper/confirm",
              qs.stringify({
                id: this.id,
                confirm: 0,
                ...this.ruleForm
              })
            );
            this.$message.success("操作成功");
            this.$emit("success");
            this.close();
          } catch (e) {
          } finally {
            this.loading = false;
          }
        } else {
          return false;
        }
      });
    }
  },
  watch: {
    dialogVisible(newVal) {
      newVal && this.initData();
    }
  },
  components: {}
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/personal/order/detail/components/refuseDialog/index.vue